import { REPORTGENERAL } from "@/config";
import { EmbeddedReport } from "../components/EmbeddedReport";

export default function ReportGeneralPage() {
  return (
    <EmbeddedReport
      title="Reporte general"
      description="Resumen general de movimientos y stock de la zona."
      src={REPORTGENERAL}
    />
  );
}
